/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 document.addEventListener('DOMContentLoaded', function () {
  const path = window.theme.path;
  const thankYouPage = "/pages/dankeschon-newsletteranmeldung";

  if(path && path == "/account/subscribe") {
    window.location.pathname = thankYouPage;
  }

  const blackweekPDP = document.querySelector('#shopify-section-product-template-blackweek');
  const pageContainer = document.querySelector('.PageContainer');

  const colorBlack = (element) => {
    element.style.color = "white";
    element.style.backgroundColor = "black";
  }

  if (blackweekPDP && pageContainer) {
    const productTabs = document.querySelector('[data-station-tabs-app]');
    pageContainer.style.backgroundColor = "black";

    if (productTabs) {
      productTabs.querySelectorAll('p').forEach((p) => {
        colorBlack(p);
      });
      productTabs.querySelectorAll('h2').forEach((h2) => {
        colorBlack(h2);
      });
      productTabs.querySelectorAll('li').forEach((li) => {
        colorBlack(li);
      })
    }
  }
}); 